<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import {
  getPermissionTokensForAccount,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';

const route = useRoute();
const store = useStore();
const ariaLabel = 'Área da conta';

const tabs = [
  {
    key: 'meus-negocios',
    label: 'Meus negócios',
    icon: 'i-lucide-briefcase',
    routeName: 'meus_negocios_index',
    activeOn: ['meus_negocios_index'],
    permissions: ['administrator', 'agent', 'agency_manage'],
  },
  {
    key: 'minha-lais',
    label: 'Minha Laís',
    icon: 'i-lucide-settings',
    routeName: 'minha_lais_index',
    activeOn: [
      'minha_lais_index',
      'minha_lais_whatsapp_catalog_index',
      'minha_lais_whatsapp_catalog_new',
      'minha_lais_whatsapp_catalog_show',
      'minha_lais_whatsapp_catalog_edit',
      'general_settings_index',
    ],
    permissions: ['administrator', 'agent', 'agency_manage'],
  },
  {
    key: 'administracao',
    label: 'Administração',
    icon: 'i-lucide-shield-check',
    routeName: 'administracao_index',
    activeOn: [
      'administracao_index',
      'administracao_qualidade_fraude_index',
      'administracao_parceiros_index',
    ],
    permissions: ['administrator'],
  },
  {
    key: 'conta',
    label: 'Conta',
    icon: 'i-lucide-user-round-cog',
    routeName: 'conta_index',
    params: { section: 'meus-dados' },
    activeOn: ['conta_index', 'deletar_conta_sucesso_index'],
    permissions: ['administrator', 'agent', 'custom_role'],
  },
  {
    key: 'acessos',
    label: 'Acessos',
    icon: 'i-lucide-users',
    routeName: 'agent_list',
    activeOn: [
      'agent_list',
      'settings_teams_list',
      'settings_teams_new',
      'settings_teams_finish',
      'settings_teams_add_agents',
      'settings_teams_edit',
      'settings_teams_edit_members',
      'settings_teams_edit_finish',
    ],
    permissions: ['administrator'],
  },
  {
    key: 'notificacoes',
    label: 'Notificações',
    icon: 'i-lucide-bell',
    routeName: 'notifications_index',
    activeOn: ['notifications_index'],
    permissions: ['administrator', 'agent', 'custom_role'],
  },
  {
    key: 'seguranca',
    label: 'Segurança',
    icon: 'i-lucide-shield',
    routeName: 'security_settings_index',
    activeOn: ['security_settings_index'],
    permissions: ['administrator'],
  },
];

const currentPermissions = computed(() =>
  getPermissionTokensForAccount(store.getters.getCurrentAccount || {})
);

const visibleTabs = computed(() =>
  tabs.filter(tab => hasPermissions(tab.permissions, currentPermissions.value))
);

const isActive = tab =>
  [tab.routeName, ...(tab.activeOn || [])].includes(route.name);

const tabTarget = tab => ({
  name: tab.routeName,
  params: {
    accountId: route.params.accountId,
    ...(tab.params || {}),
  },
});
</script>

<template>
  <nav
    :aria-label="ariaLabel"
    class="border-b border-lais-border-rule bg-white px-4 sm:px-6 lg:px-10"
  >
    <div class="flex items-center gap-6 overflow-x-auto no-scrollbar">
      <RouterLink
        v-for="tab in visibleTabs"
        :key="tab.key"
        :to="tabTarget(tab)"
        class="relative inline-flex h-12 shrink-0 items-center gap-2 text-[14px] font-semibold transition-colors"
        :class="
          isActive(tab)
            ? 'text-lais-primary'
            : 'text-lais-text-muted hover:text-lais-text-body'
        "
      >
        <span class="size-4 shrink-0" :class="tab.icon" aria-hidden="true" />
        <span>{{ tab.label }}</span>
        <span
          v-if="isActive(tab)"
          class="absolute bottom-0 left-0 right-0 h-[3px] rounded-t bg-lais-primary"
        />
      </RouterLink>
    </div>
  </nav>
</template>
